import { Component, Ref, Vue, Watch } from 'vue-property-decorator'
import PaginationRequest from '@/common/pagination/entities/pagination-request'
import UserDialog from '@/users/components/user-dialog/user-dialog'
import User from '@/users/entities/user'
import accountService from '@/users/services/account-service'
import usersService from '@/users/services/users-service'
import authService from '@/users/services/auth-service'
import Guid from '@/app/utils/guid'

@Component
export default class Users extends Vue {
  @Ref()
  private dialog!: UserDialog

  private loading: boolean = false
  private users: User[] = []

  private pagination = new PaginationRequest()

  private status = [
    { text: 'alle', value: '' },
    { text: 'aktiv', value: 'active' },
    { text: 'E-Mail nicht bestätigt', value: 'notConfirmed' },
    { text: 'Gesperrt', value: 'disabled' },
  ]

  public async fetchAll() {
    this.loading = true
    const response = await usersService.findAllAsync(this.pagination)
    this.users = response.items
    this.pagination.totalItems = response.totalItems
    this.loading = false
  }

  public async exportUsers() {
    console.log(JSON.stringify(this.pagination))
    const response = await usersService.export(
      this.pagination.search,
      this.pagination.onlyNewsletter,
      this.pagination.status,
      this.pagination.notInvoiced
    )
    const blob = new Blob([response], { type: 'text/csv' })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = 'users.csv'
    a.click()
    window.URL.revokeObjectURL(url)
  }

  public openNew() {
    this.dialog.openNew(new User())
  }

  public openEdit(user: User) {
    this.dialog.openEdit(user)
  }

  public async impersonate(user: User) {
    await authService.impersonate({
      email: user.email,
      password: '',
      rememberMe: false,
    })
  }

  public async create(user: User) {
    await accountService.saveAsync(user)
    await this.fetchAll()
  }

  public async update(user: User) {
    console.log(user)
    await accountService.updateAsync(user)
    await this.fetchAll()
  }

  private async enable(user: User) {
    await accountService.enableAsync(user)
    await this.fetchAll()
  }

  private async disable(user: User) {
    await accountService.disableAsync(user)
    await this.fetchAll()
  }

  private async remove(user: User) {
    await accountService.removeAsync(user.id)
    await this.fetchAll()
  }

  @Watch('pagination.status')
  private async statusChanged(newStatus: string, oldStatus: string) {
    if (newStatus !== oldStatus) {
      await this.fetchAll()
    }
  }

  @Watch('pagination.search')
  private async searchChanged(newSearch: string, oldSearch: string) {
    if (newSearch !== oldSearch) {
      await this.fetchAll()
    }
  }

  @Watch('pagination.onlyNewsletter')
  private async onlyNewsletterChanged(newVal: boolean, oldVal: boolean) {
    if (newVal !== oldVal) {
      await this.fetchAll()
    }
  }

  private async mounted() {
    await this.fetchAll()
  }
}
